// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"43737e54","382":"2392651f","484":"ae3f6dae","604":"a7c3541e","616":"f8cd7241","889":"aa7e96bb"}[chunkId] + ".chunk.js";
};